'use client'

import Image from 'next/image'

interface GoogleAuthButtonProps {
  className?: string
}

export default function GoogleAuthButton({ className = '' }: GoogleAuthButtonProps) {
  return (
    <a
      href="/api/auth/google"
      className={`flex items-center justify-center px-8 h-12  rounded-full shadow-sm bg-white border border-slate-200 text-xs font-bold text-slate-600 hover:bg-slate-50 hover:border-slate-300 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 cursor-pointer w-auto ${className}`}
      rel="noopener noreferrer"
    >
      <Image className="h-4 w-4 mr-2" width={24} height={24} src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" />
      Continuar con Google
    </a>
  )
}